import React, { useState } from 'react';
import AppService from '../services/AppService';
import { toast } from 'react-toastify';
import './ReportModal.css';

const ReportModal = ({ show, onClose, targetId, targetType, reporterId }) => {
    const [reason, setReason] = useState("");
    const [description, setDescription] = useState("");
    const [loading, setLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    if (!show) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason) {
            toast.error("Please select a reason");
            return;
        }

        setLoading(true);
        setErrorMessage("");

        const reportData = {
            reporterId: reporterId,
            targetId: targetId,
            targetType: targetType,
            reasonCode: reason,
            description: description
        };

        try {
            const response = await AppService.submitReport(reportData);
            if (response.data && response.data.status) {
                setIsSubmitted(true);
                // Reset form
                setReason("");
                setDescription("");
                // Auto close after 2.5 seconds
                setTimeout(() => {
                    onClose();
                    setIsSubmitted(false);
                    setErrorMessage("");
                }, 2500);
            } else {
                // Handle status:false response (shouldn't reach here with 409, but just in case)
                const message = response.data?.message || response.data?.data || "Failed to submit report";
                setErrorMessage(message);
                toast.error(message);
            }
        } catch (error) {
            console.error("Report error:", error);
            // Extract the error message from the API response
            const errorMsg =
                error.response?.data?.message ||
                error.response?.data?.data ||
                "An error occurred while reporting";
            setErrorMessage(errorMsg);
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="report-modal-overlay">
            <div className="report-modal-container">
                <div className="report-modal-header">
                    <h3>{isSubmitted ? 'Success' : `Report ${targetType === 'LISTING' ? 'Ad' : 'User'}`}</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                {isSubmitted ? (
                    <div className="report-success-view">
                        <div className="success-icon">
                            <i className="fa fa-check-circle"></i>
                        </div>
                        <h3>Report Submitted!</h3>
                        <p>Our team will review this shortly. Thank you for keeping the marketplace safe.</p>
                        <button className="btn-cancel" onClick={onClose}>Close</button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div className="report-modal-body">
                            {/* Inline error banner — always visible when there's an error */}
                            {errorMessage && (
                                <div className="report-error-banner">
                                    <i className="fa fa-exclamation-circle"></i>
                                    <span>{errorMessage}</span>
                                </div>
                            )}

                            <div className="form-group">
                                <label>Why are you reporting this?</label>
                                <select
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Select a reason</option>
                                    <option value="FAKE">Fake Ad / Scam</option>
                                    <option value="SPAM">Spam</option>
                                    <option value="INAPPROPRIATE">Inappropriate Content</option>
                                    <option value="DUPLICATE">Duplicate Listing</option>
                                    <option value="OTHER">Other</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Additional Details (Optional)</label>
                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Provide more context..."
                                    className="form-control"
                                    rows="4"
                                ></textarea>
                            </div>
                        </div>
                        <div className="report-modal-footer">
                            <button type="button" className="btn-cancel" onClick={onClose} disabled={loading}>Cancel</button>
                            <button type="submit" className="btn-submit" disabled={loading || !reason}>
                                {loading ? (
                                    <>
                                        <i className="fa fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                                        Submitting...
                                    </>
                                ) : "Submit Report"}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default ReportModal;
